import { PortfolioView } from './components/PortfolioView';

export default function TumPortfolio() {
  return (
    <div className="container mx-auto p-6 space-y-6">
      <div className="space-y-2">
        <h1 className="text-4xl font-bold tracking-tight">Portfolio View</h1>
        <p className="text-muted-foreground mt-2 text-lg">
          Visualize your utility data with customizable widgets and dashboards
        </p>
      </div>
      <PortfolioView />
    </div>
  );
}

